import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { SearchResultsLayout } from '../Common/SearchResultsLayout/SearchResultsLayout';
import { bigCommerceDecisionTreeSelectOrder } from '../../../../../../../actions/tools/BigCommerceActions';

const SearchResultsBigCommerce = () => {
  const dispatch = useDispatch();

  const handleSelectOrder = useCallback(
    (order) => {
      return dispatch(bigCommerceDecisionTreeSelectOrder(order));
    },
    [dispatch]
  );

  return <SearchResultsLayout onSelectOrder={handleSelectOrder} />;
};

export default SearchResultsBigCommerce;
